import './local.css'
import skopiaimg from '../../assets/skopiaimg2.png'
import iconzap from '../../assets/iconzap.jpg'

function Local(){
    return(
        <div class='local-main'>
            <h2 class="text-main">Onde atendemos</h2>
            <img src={skopiaimg} className='local-img'/>
            <h4 className='text-second'>Skopia Clínica</h4>
            <h5 className='text-second'>Endereço: Rua Maria Auxiliadora, 804. Tirol - Natal-RN</h5>            
            <h5 className='text-second'>Contatos: <img src={iconzap} className='iconzap'/> (84) 99473-3788 | (84) 3198-1900 | (84) 3198-1901</h5>

        </div>
    )
}

export default Local